import type { FormInstance } from '@arco-design/web-react/es/Form';
import get from 'lodash/get';

import type { CommonImageItemType } from '../types';

export interface ContainerImageFormFieldMapping {
  field: string;
  getValueField?: string;
  /** 固定值，优先生效 */
  value?: string;
  transform?: (raw: unknown, item: CommonImageItemType) => unknown;
}

/** 将容器制品元数据写入表单字段（需配合同名 hidden Form.Item 才能在 validate 中带回） */
export function applyContainerImageItemToForm(form: FormInstance, item: CommonImageItemType, mappings: ContainerImageFormFieldMapping[]) {
  mappings.forEach(({ field, getValueField, value, transform }) => {
    let next: unknown = value !== undefined ? value : getValueField ? get(item, getValueField) : undefined;
    if (transform) {
      next = transform(next, item);
    }
    if (next === undefined || next === null) {
      next = '';
    }
    form.setFieldValue(field, next);
  });
}

/**
 * 按 system 字段前缀生成镜像元数据映射，对齐 ResourceSystemInfomation。
 * @param systemFieldPrefix 表单中 system 对象路径，如 headGroupSpec.system、system、basic.image
 */
export function createSystemImageFieldMappings(systemFieldPrefix: string): ContainerImageFormFieldMapping[] {
  const prefix = String(systemFieldPrefix ?? 'basic.image').replace(/\.$/, '');
  return [
    { field: `${prefix}.image`, getValueField: 'dockerRefUrl' },
    { field: `${prefix}.url`, getValueField: 'dockerRefUrl' },
    { field: `${prefix}.imageName`, getValueField: 'name' },
    {
      field: `${prefix}.architecture`,
      getValueField: 'cpuArchitectures[0]',
      transform: (raw) => String(raw ?? '').trim(),
    },
    { field: `${prefix}.type`, value: 'Container' },
    { field: `${prefix}.os`, getValueField: 'vendor' },
    { field: `${prefix}.version`, getValueField: 'version' },
    { field: `${prefix}.kernelVersion`, getValueField: 'kernelVersion' },
    { field: `${prefix}.artifactType`, getValueField: 'artifactType' },
    { field: `${prefix}.packageFormat`, getValueField: 'packageFormat' },
    { field: `${prefix}.dockerSourceSize`, getValueField: 'dockerSourceSize' },
    { field: `${prefix}.httpSourceSize`, getValueField: 'httpSourceSize' },
    { field: `${prefix}.systemDiskSize`, getValueField: 'options.systemImage.systemVolumeSize' },
    {
      field: `${prefix}.bootloader`,
      getValueField: 'options.systemImage.bootloader',
      transform: (raw) => (raw ? String(raw) : 'BIOS'),
    },
  ];
}
